module.exports = __webpack_public_path__ + "static/media/broadcast.d95c34da.svg";